import { useLocation, useParams } from "react-router-dom";
import SilaAnimalsProfile from "@/features/Animals/SilaAnimalsProfile.tsx";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog.tsx";
import { Button } from "@/components/ui/button.tsx";
import { Checkbox } from "@/components/ui/checkbox.tsx";
import { Label } from "@/components/ui/label.tsx";
import { useState } from "react";
import { useGetSilaAnimal } from "@/features/Animals/animalApiSlice.ts";
import WhatsAppChat from "@/components/ui/whatsapp-chat.tsx";

// @ts-ignore
// const html2pdf = ( await import( "html2pdf.js" ) ).default as any

export const Home = () => {
  const { id } = useParams<{ id: string }>();
  const { data } = useGetSilaAnimal(id);
  const location = useLocation();
  // const contentRef = useRef<HTMLDivElement>( null )

  // const animalName = data?.name ?? @Pro"Animal Profile"

  // const generatePDF = useCallback(
  //   async ( options: {
  //     includeImages: boolean
  //     includeHealthRecords: boolean
  //     includePedigree: boolean
  //     includeOwnerInfo: boolean
  //     highQuality: boolean
  //   } ) => {
  //     if ( !contentRef.current )
  //     {
  //       console.error( "Could not find overview section" )
  //       return
  //     }

  //     try
  //     {
  //       // Clone the section to modify for PDF
  //       const element = contentRef.current.cloneNode( true ) as HTMLElement
  //       let pagebreak = {
  //         before: ".before",
  //         after: ".after",
  //         avoid: ".avoid",
  //       }
  //       // Remove interactive elements
  //       const buttonsToRemove = element.querySelectorAll(
  //         ".flex.flex-col.sm\\:flex-row.gap-4.justify-end",
  //       )
  //       buttonsToRemove.forEach( ( btn ) => btn.remove() )

  //       // Conditionally remove sections
  //       if ( !options.includeOwnerInfo )
  //       {
  //         const cardTitles = element.querySelectorAll( '[class*="CardTitle"]' )
  //         let ownerSection: any = null
  //         cardTitles.forEach( ( title ) => {
  //           if ( title.textContent?.includes( "Breeder/Owner" ) )
  //           {
  //             ownerSection = title.closest( ".mt-4" )
  //           }
  //         } )
  //         if ( ownerSection ) ownerSection.remove()
  //       }

  //       if ( !options.includeHealthRecords )
  //       {
  //         const cardTitles = element.querySelectorAll( '[class*="CardTitle"]' )
  //         let healthSection: any = null
  //         cardTitles.forEach( ( title ) => {
  //           if ( title.textContent?.includes( "Recent Health" ) )
  //           {
  //             healthSection = title.closest( 'div[class*="Card"]' )
  //           }
  //         } )
  //         if ( healthSection ) healthSection.remove()
  //       }

  //       if ( !options.includePedigree )
  //       {
  //         const cardTitles = element.querySelectorAll( '[class*="CardTitle"]' )
  //         let breedingSection: any = null
  //         cardTitles.forEach( ( title ) => {
  //           if ( title.textContent?.includes( "Breeding Information" ) )
  //           {
  //             breedingSection = title.closest( 'div[class*="Card"]' )
  //           }
  //         } )
  //         if ( breedingSection ) breedingSection.remove()
  //       }

  //       // Handle images based on options
  //       if ( !options.includeImages )
  //       {
  //         const images = element.querySelectorAll( "img" )
  //         images.forEach( ( img ) => {
  //           const placeholder = document.createElement( "div" )
  //           placeholder.style.width = "100%"
  //           placeholder.style.height = "100%"
  //           placeholder.style.backgroundColor = "#f0f0f0"
  //           placeholder.style.display = "flex"
  //           placeholder.style.alignItems = "center"
  //           placeholder.style.justifyContent = "center"
  //           placeholder.textContent = "Image placeholder"
  //           img.parentNode?.replaceChild( placeholder, img )
  //         } )
  //       } else
  //       {
  //         // Force all images to have crossOrigin attribute
  //         const images = element.querySelectorAll( "img" )
  //         images.forEach( ( img ) => {
  //           img.crossOrigin = "anonymous"

  //           // If using relative URLs, convert them to absolute
  //           if (
  //             img.src &&
  //             !img.src.startsWith( "http" ) &&
  //             !img.src.startsWith( "data:" )
  //           )
  //           {
  //             img.src = new URL( img.src, window.location.origin ).href
  //           }

  //           // Add a small delay to ensure images are processed
  //           img.style.maxWidth = "100%"
  //           img.style.height = "auto"
  //         } )
  //       }

  //       // Add a title at the top
  //       //   const titleDiv = document.createElement("div");
  //       //   titleDiv.innerHTML = `
  //       //   <div style="width: 100%; max-width: 1200px: ; text-align: center;
  //       // margin: "0 auto"; padding: 20px; border-bottom: 1px solid #e5e7eb;">
  //       // <h1 style="font-size: 28px; font-weight: bold; margin-bottom:
  //       // 8px;">${data?.name} - Animal Profile</h1> <p style="font-size: 16px;
  //       // color: #6b7280;">${data?.racialComposition ?? data?.breed} |
  //       // ${data?.sex} | Born: ${new Date( data?.birthDate,
  //       // ).toLocaleDateString()}</p> <p style="font-size: 14px; color: #9ca3af;
  //       // margin-top: 8px;">Generated on ${new Date().toLocaleDateString()} ${new
  //       // Date().toLocaleTimeString()}</p> </div> `;
  //       // element.insertBefore(titleDiv, element.firstChild);

  //       // Pre-load all images before generating PDF
  //       const images = element.querySelectorAll( "img" )
  //       // console.log(`Found ${images.length} images to process`);

  //       // Wait for all images to load or timeout after 3
  //       // seconds
  //       const imagePromises = Array.from( images ).map( ( img ) => {
  //         if ( img.complete || !img.src ) return Promise.resolve()
  //         return new Promise( ( resolve ) => {
  //           img.onload = resolve
  //           img.onerror = resolve // Resolve even on error to
  //           // avoid blocking
  //           // Ensure we load a fresh copy of the image
  //           if ( img.src.indexOf( "?" ) === -1 )
  //           {
  //             img.src = img.src + "?" + new Date().getTime()
  //           }
  //         } )
  //       } )

  //       await Promise.race( [
  //         Promise.all( imagePromises ),
  //         new Promise( ( resolve ) => setTimeout( resolve, 3000 ) ), // 3s timeout
  //       ] )

  //       // console.log("Images processed, generating PDF");

  //       // Set options for the PDF
  //       const opt = {
  //         margin: [ 10, 10, 10, 10 ],
  //         filename: `${animalName}-profile-SGIP.pdf`,
  //         image: {
  //           type: "jpeg",
  //           quality: options.highQuality ? 0.95 : 0.8,
  //         },
  //         html2canvas: {
  //           scale: options.highQuality ? 4 : 2,
  //           useCORS: true,
  //           allowTaint: true, // Allow loading of tainted
  //           // images
  //           letterRendering: true,
  //           logging: true, // For debugging
  //           imageTimeout: 5000, // Longer timeout for images
  //         },
  //         pagebreak: pagebreak,
  //         jsPDF: {
  //           unit: "mm",
  //           format: "a3",
  //           orientation: "portrait",
  //           compress: true,
  //         },
  //       }

  //       // Generate the PDF
  //       await html2pdf().from( element ).set( opt ).save()

  //       // console.log("PDF generated successfully");
  //     } catch ( error )
  //     {
  //       console.error( "Error generating PDF:", error )
  //       throw error
  //     }
  //   },
  //   [],
  // )
  return (
    <main className="min-h-screen w-screen flex flex-col">
      {/* <div className="flex justify-end  relative"> */}
      {/*   <Link to={`/search-animal`}> */}
      {/*     <Button size="sm" className="gap-1"> */}
      {/*       Go Back <ArrowLeft className="h-4 w-4" /> */}
      {/*     </Button> */}
      {/*   </Link> */}
      {/* </div> */}
      <div id={"pdf-content"} className={"w-full"}>
        {/* <PDFWrapper animalData={ yourAnimalData } showViewer={ true } />  */}
        <SilaAnimalsProfile
          key={location.pathname}
          // id={id ?? ""}
          animalData={data}
        />
      </div>

      {/* <EnhancedPdfGenerator
				 animalName={ data?.name ?? "Animal" }
				 breed={ data?.racialComposition ?? "unknown" }
				 generatePdfFunction={ generatePDF }
				 /> */}

      {/* <SilaAnimalsProfilePDF {...data} /> */}
      <WhatsAppChat
        phoneNumber="+234 912 800 6892"
        position="bottom-right"
        showTooltip={true}
      />
      {/* Legend and instructions */}
      {/* <div className="mt-8 bg-gray-50 p-4 rounded-lg"> */}
      {/*   <h3 className="font-medium mb-2">How to Use</h3> */}
      {/*   <ul className="text-sm space-y-1 text-gray-700"> */}
      {/*     <li>• Select an animal from the dropdown to view its pedigree</li> */}
      {/*     <li>• The selected animal appears at the top of the tree</li> */}
      {/*     <li>• Parents (Sire and Dam) appear in the second row</li> */}
      {/*     <li>• Grandparents appear in the third row</li> */}
      {/*     <li>• Click on any animal card to see more details</li> */}
      {/*     <li>• DGR numbers are displayed as registration information</li> */}
      {/*   </ul> */}
      {/* </div> */}
    </main>
  );
};

export interface PdfOptions {
  includeImages: boolean;
  includeHealthRecords: boolean;
  includePedigree: boolean;
  includeOwnerInfo: boolean;
  highQuality: boolean;
}

export interface EnhancedPdfGeneratorProps {
  animalName: string;
  breed: string;
  generatePdfFunction: (options: PdfOptions) => Promise<void>;
}

export function EnhancedPdfGenerator({
  animalName,
  breed,
  generatePdfFunction,
}: EnhancedPdfGeneratorProps) {
  const [isGenerating, setIsGenerating] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [options, setOptions] = useState<PdfOptions>({
    includeImages: true,
    includeHealthRecords: true,
    includePedigree: true,
    includeOwnerInfo: true,
    highQuality: true,
  });

  const handleOptionChange = (option: keyof PdfOptions) => {
    setOptions((prev) => ({
      ...prev,
      [option]: !prev[option],
    }));
  };

  const handleGeneratePdf = async () => {
    setIsGenerating(true);
    try {
      await generatePdfFunction(options);
      setIsDialogOpen(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
      // alert("There was an error generating the PDF. Please try again.");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button
          size={"sm"}
          className="flex items-center gap-2 w-24 self-center"
        >
          {/*<Download className="h-4 w-4" />*/}
          Download PDF
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Generate PDF for {animalName}</DialogTitle>
          <DialogDescription>
            Customize the content to include in the {breed} cattle profile PDF.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="flex items-center space-x-2">
            <Checkbox
              id="includeImages"
              checked={options.includeImages}
              onCheckedChange={() => handleOptionChange("includeImages")}
            />
            <Label htmlFor="includeImages">Include images</Label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="includeHealthRecords"
              checked={options.includeHealthRecords}
              onCheckedChange={() => handleOptionChange("includeHealthRecords")}
            />
            <Label htmlFor="includeHealthRecords">Include health records</Label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="includePedigree"
              checked={options.includePedigree}
              onCheckedChange={() => handleOptionChange("includePedigree")}
            />
            <Label htmlFor="includePedigree">
              Include pedigree information
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="includeOwnerInfo"
              checked={options.includeOwnerInfo}
              onCheckedChange={() => handleOptionChange("includeOwnerInfo")}
            />
            <Label htmlFor="includeOwnerInfo">Include owner information</Label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="highQuality"
              checked={options.highQuality}
              onCheckedChange={() => handleOptionChange("highQuality")}
            />
            <Label htmlFor="highQuality">High quality (larger file size)</Label>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={handleGeneratePdf} disabled={isGenerating}>
            {isGenerating ? <>Generating...</> : "Generate PDF"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
